import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RepoSettingsService } from '../../../../../data/repositories/repo-settings.service';
import { RouterStateService } from '../../../../../core/routing/router-state.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-sidebar2-checkbox',
    templateUrl: './sidebar2-checkbox.component.html',
    standalone: false,
})
export class Sidebar2CheckboxComponent implements OnInit {
    dropdownOpen = true;
    // @ts-ignore TS2564
    selections: string[];
    DELIMITER = '|';

    // to disable filters
    @Input() disableFilter = false;
    // @ts-ignore TS2564
    @Input() statuses: FilterStatus[];
    @Input() routeParam = 'status';
    // @ts-ignore TS2564
    @Input() settingsFlag: string; // NavigationV2Estimates
    // @ts-ignore TS2564
    @Input() defaultRoute: string; // '/estimates/list'
    @Output() refetchQuery = new EventEmitter<boolean>();
    constructor(
        public settings: RepoSettingsService,
        private routerStateService: RouterStateService,
        private router: Router
    ) {}

    ngOnInit() {
        this.getSelections(this.defaultRoute);
    }

    // @ts-ignore TS7006
    getSelections(destRoute) {
        if (!destRoute && this.routerStateService.currentRoute?.queryParams[this.routeParam]) {
            this.selections = this.routerStateService.currentRoute?.queryParams[this.routeParam].split('|');
        } else {
            // @ts-ignore TS7052
            if (this.settings[`${this.settingsFlag}StatusSelections`]) {
                // @ts-ignore TS7052
                this.selections = this.settings[`${this.settingsFlag}StatusSelections`].split(this.DELIMITER);
            }
            // @ts-ignore TS2322
            if (!this.selections) this.selections = this._useAllStatuses();
        }
    }

    // @ts-ignore TS7006
    toggleSelection(item) {
        const convertedItem = this.convertKey(item);
        if (this.selections === undefined) this.selections = [];

        // @ts-ignore TS2345
        const idx = this.selections.indexOf(convertedItem);
        if (idx > -1) {
            // Is currently selected
            if (convertedItem === 'all') {
                this.selections = [];
            } else {
                this.selections.splice(idx, 1);
                const lowerCaseSelections = this.selections.map((s) => s.toLowerCase());
                const indexOfAll = lowerCaseSelections.indexOf('all');
                if (indexOfAll !== -1) this.selections.splice(indexOfAll, 1); // Remove all from start too
            }
        } else {
            // Is newly selected
            if (convertedItem === 'all') {
                // @ts-ignore TS2322
                this.selections = this._useAllStatuses();
            } else {
                // @ts-ignore TS2345
                this.selections.push(convertedItem); // Part of pushing all items in as selected for default list of cb/rd switches
            }
        }

        const remappedSelections = this.selections.length ? this.selections.join('|') : '';
        let destParams = this.routerStateService.currentRoute?.queryParams ?? {};
        destParams[this.routeParam] = remappedSelections;
        // @ts-ignore TS7052
        this.settings[`${this.settingsFlag}StatusSelections`] = remappedSelections;

        const destRoute = [this.defaultRoute] || [];
        this.router.navigate(destRoute, { queryParams: destParams, queryParamsHandling: 'replace', onSameUrlNavigation: 'reload' });
    }

    convertKey(item: string | FilterStatus) {
        if (typeof item === 'string') return item.toLowerCase().split(' ').join('');

        const key = item.Status;
        if (typeof key === 'string') return key.toLowerCase().split(' ').join('');
        return '';
    }

    _useAllStatuses() {
        if (!this.statuses || this.statuses.length < 1) return;
        const selections = [];
        for (const s in this.statuses) {
            if (this.convertKey(s) !== 'bin') {
                const status = this.statuses[s];
                if (status) selections.push(this.convertKey(status));
            }
        }
        return selections;
    }
}

export class FilterStatus {
    // @ts-ignore TS2564
    Status: string;
    // @ts-ignore TS2564
    Quantity: number;
}
